import React, { useMemo } from 'react';
import {
  ElementName,
  ElementType,
  HomepageSectionProps,
  HomepageSectionVariants,
  HorizontalSaleCardSectionBase,
  type IContentElementProps,
  IPageName,
  TrackingContext,
  getPaths,
} from '@secretescapes/cauldron';
import { Button, ButtonVariant, InfoBox, InfoBoxSize, InfoBoxVariant } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { type RecommendedSalesProps } from './RecommendedSales.interfaces';
import { RecommendedSalesContainer, SeeDealsButtonWrapper } from './RecommendedSales.styles';

export const RecommendedSales = ({
  isExpiredSale,
  title,
  saleIds,
  isMobile,
}: RecommendedSalesProps) => {
  const { translations } = useTranslations();

  const navigateToCurrentSalesPage: () => void = () => {
    window.location.assign(getPaths(IPageName.currentSales)[0]);
  };

  const trackingElement: IContentElementProps = useMemo(
    () => ({
      elementType: isExpiredSale ? ElementType.EXPIRED_SALE : ElementType.NON_EXPIRED_SALE,
      elementName: ElementName.RECOMMENDED_FOR_YOU,
    }),
    [isExpiredSale]
  );

  return (
    <TrackingContext.Provider value={trackingElement}>
      <RecommendedSalesContainer isMobile={isMobile} expiredSale={isExpiredSale}>
        {isExpiredSale ? (
          <InfoBox
            subTitle={i18n('recommendedSales.title', [], translations)}
            title={i18n('sale.expired.info', [], translations)}
            variant={InfoBoxVariant.alert}
            size={isMobile ? InfoBoxSize.small : InfoBoxSize.large}
          />
        ) : null}
        <HorizontalSaleCardSectionBase
          variables={{
            ...HomepageSectionProps[HomepageSectionVariants.searchRecommendations],
            titleKey: title ?? '',
            queryVariables: { saleIds },
          }}
          elementType={isExpiredSale ? ElementType.EXPIRED_SALE : ElementType.NON_EXPIRED_SALE}
        />
        {isExpiredSale ? (
          <SeeDealsButtonWrapper>
            <Button
              variant={ButtonVariant.primary}
              fullWidth={isMobile}
              onClick={navigateToCurrentSalesPage}
            >
              {i18n('cancellation.see.deals', [], translations)}
            </Button>
          </SeeDealsButtonWrapper>
        ) : null}
      </RecommendedSalesContainer>
    </TrackingContext.Provider>
  );
};
